// extracted by mini-css-extract-plugin
module.exports = {"relative":"TradesPerAssetPairDonut_relative_2vQKU"};